export enum SequenceEnum {
  SUBJECT = "subject",
  CHAPTER = "chapter",
  LESSON = "lesson",
  SKILL = "skill",
  SUBJECT_NOTE = "subject_note",
  LECTURE = "lecture",
  GRADE = "grade",
  FLASH_CARD = "flash_card",
  PLAN = "plan",
  SUBJECT_SYSTEM_INSTRUCTION = "subject_system_instruction",
  LECTURE_ASSIGNMENT = "lecture_assignment",
  ASSIGNMENT_QUESTION = "assignment_question",
  CATEGORY = "category",
  FEATURE = "feature",
  EDUCATION_SYSTEM = "education_system",
  CURRICULUM = "curriculum",
  EDUCATIONAL_STAGE = "educational_stage",
}
